import { render, staticRenderFns } from "./recipients-table-edit.vue?vue&type=template&id=7fe07882&scoped=true&"
import script from "./recipients-table-edit.vue?vue&type=script&lang=js&"
export * from "./recipients-table-edit.vue?vue&type=script&lang=js&"
import style0 from "./recipients-table-edit.vue?vue&type=style&index=0&id=7fe07882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe07882",
  null
  
)

export default component.exports